<!-- Harmonize_Intracerebral_Hemorrhage_GWAS_2014 Phenotypes documentation -->
<div [innerHTML]="filteredHtml"></div>